import {useEffect, useRef, useState} from "react";
import {TextInput} from "@mantine/core";
import {useDebouncedValue} from "@mantine/hooks";
import {useTranslation} from "react-i18next";
import IconSearch from "../../../assets/search.svg?react";
import styles from "./checklist.module.css";

type SearchInputProps = {
    initialValue?: string;
    onChange: (value: string) => void;
    resetKey?: string | number;
};

export const SearchInput = ({
    initialValue = "",
    onChange,
}: SearchInputProps) => {
    const {t} = useTranslation();
    const [value, setValue] = useState(initialValue);
    const [debounced] = useDebouncedValue(value, 600);
    const lastSent = useRef(initialValue);

    useEffect(() => {
        if (debounced !== lastSent.current) {
            lastSent.current = debounced;
            onChange(debounced);
        }
    }, [debounced, onChange]);

    return (
        <TextInput
            value={value}
            onChange={(e) => setValue(e.currentTarget.value)}
            size="sm"
            leftSection={<IconSearch width={16} height={16} />}
            placeholder={t("common.search")}
            aria-label={t("common.search")}
            className={styles.checklistSearch}
        />
    );
};
